import { render, staticRenderFns } from "./animalDataItem.vue?vue&type=template&id=6f75cb58"
import script from "./animalDataItem.vue?vue&type=script&lang=js"
export * from "./animalDataItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports